import { createStore,combineReducers,applyMiddleware,compose  } from 'redux'
import thunk from "redux-thunk"
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import AppRedux from '../redux/reducers/AppRedux'
import MasterRedux from '../redux/reducers/MasterRedux'
import MainRedux from '../redux/reducers/MainRedux'
import UserRedux from '../redux/reducers/UserRedux'
import UserManualRedux from '../redux/reducers/UserManualRedux'
import UploadRedux from '../redux/reducers/UploadRedux'
import MyTaskRedux from '../redux/reducers/MyTaskRedux';
import SearchRedux from '../redux/reducers/SearchRedux'
import ModalEmployeeRedux from '../redux/reducers/ModalEmployeeRedux'
import ModalVendorRedux from '../redux/reducers/ModalVendorRedux'
import ModalCostCenterRedux from '../redux/reducers/ModalCostCenterRedux'
import AssetRedux from '../redux/reducers/AssetRedux'
import DepartmentMapRedux from '../redux/reducers/DepartmentMapRedux'
import DocControlRedux from '../redux/reducers/DocControlRedux'
import ContractPORedux from '../redux/reducers/ContractPORedux'
import ApproveRedux from '../redux/reducers/ApproveRedux'
import EmailTemplateRedux from '../redux/reducers/EmailTemplateRedux'
// let composeEnhancers =  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let composeEnhancers = compose;

let rootReducer  = combineReducers({
    AppRedux,
    MasterRedux,
    MainRedux,
    UserRedux,
    UserManualRedux,
    UploadRedux,
    MyTaskRedux,
    SearchRedux,
    ModalEmployeeRedux,
    ModalVendorRedux,
    ModalCostCenterRedux,
    AssetRedux,
    DepartmentMapRedux,
    DocControlRedux,
    ContractPORedux,
    ApproveRedux,
    EmailTemplateRedux,
});

const persistConfig = {
    key: 'root',
    storage: storage,
    //blacklist: []
    whitelist: ['MasterRedux']
  }

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default () => {
    let store = createStore(persistedReducer, composeEnhancers(applyMiddleware(thunk)))
    //let store = createStore(persistedReducer, composeEnhancers(applyMiddleware(thunk),Reactotron.createEnhancer()))
    let persistor = persistStore(store)
    return { store, persistor }
  }